import Vue from 'vue/dist/vue.esm.js';

let submenuData = [
  {
    'title': 'Specialist',
    'description': 'Plastic & Reconstructive Surgeon',
  },
  {
    'title': 'Member',
    'description': 'Plastic & Reconstructive Surgeon',
  },
  {
    'title': 'Specialist',
    'description': 'Plastic & Reconstructive Surgeon',
  },
  {
    'title': 'Member',
    'description': 'Plastic & Reconstructive Surgeon',
  }
]

Vue.component('submenu', {
  data() {
    return {
      activeEl: 0,
      maxLength: 0,
      submenuData: []
    }
  },
  mounted(){
    this.submenuData = submenuData;
    this.maxLength = this.submenuData.length;
  },
  methods: {
    updateIndex: function(next){
      if(next){
        this.activeEl = this.activeEl == (this.maxLength-1) ? 0 : this.activeEl + 1;
      }else {
        this.activeEl = this.activeEl == 0 ? (this.maxLength-1) : this.activeEl - 1;
      }
    }
  }
});


new Vue({}).$mount('#submenuWrapper');
